import { IntegrationCompany } from '../_modelsTS/Integration'

import logo_avaibook from './images/logo_avaibook.png'
import logo_hostify from './images/logo_hostify.png'
import logo_octorate from './images/logo_octorate.png'
import logo_kross_booking from './images/logo_kross_booking.png'
import logo_three_angular from './images/logo_three_angular.png'
import logo_smoobu from './images/logo_smoobu.jpg'
import logo_avantio from './images/logo_avantio.png'
import logo_bookipro from './images/logo_bookipro.png'
import logo_icnea from './images/logo_icnea.png'
import logo_lodgify from './images/logo_lodgify.png'
import logo_guesty from './images/logo_guesty.png'
import logo_enso_connect from './images/logo_enso_connect.png'
// Manual has no vendor behind it: its "logo" is a calendar glyph WITH the word,
// because the catalog card renders the image alone and nothing else there would
// name it.
import logo_manual from './images/logo_manual.svg'

export function integrationLogoForCompany(company) {
    switch (company) {
        case IntegrationCompany.AVAIBOOK:
            return logo_avaibook;

        case IntegrationCompany.HOSTIFY:
            return logo_hostify;

        case IntegrationCompany.OCTORATE:
            return logo_octorate;

        case IntegrationCompany.KROSS_BOOKING:
            return logo_kross_booking;

        case IntegrationCompany.THREE_ANGULAR:
            return logo_three_angular;

        case IntegrationCompany.SMOOBU:
            return logo_smoobu;

        case IntegrationCompany.AVANTIO:
            return logo_avantio;

        case IntegrationCompany.BOOKIPRO:
            return logo_bookipro;

        case IntegrationCompany.ICNEA:
            return logo_icnea;

        case IntegrationCompany.LODGIFY:
            return logo_lodgify;

        case IntegrationCompany.GUESTY:
            return logo_guesty;

        case IntegrationCompany.ENSO_CONNECT:
            return logo_enso_connect;

        case IntegrationCompany.MANUAL:
            return logo_manual;

        default:
            return logo_avaibook;
    }
}